/**
 * The assistant's place in the console's stacking order, shared by its three `fixed` forms: the
 * launcher, the floating window, and the dock below md. From md up the dock is in the page's flow
 * (`md:z-auto`) and stacks like any other column.
 *
 * The console renders its overlays in place, without portals, so all of them compete in ONE
 * stacking context, the root: the header's menus and drawers and the page modals inside `<main>`
 * alike. They come in two tiers:
 * - z-40: the mobile nav, the drawer scrims, and a few drawers.
 * - z-50: the settings and alerts drawers, the page modals and the toast stack.
 * Page content mostly stays at z-30 or below. The few in-page popovers at z-50 and up (dropdowns,
 * the map's attribute table) paint over the assistant, as they did before it moved into the row.
 *
 * The assistant goes between the two: above the page, under anything the user opens over it. The
 * value sits BETWEEN tiers, never on one, because on a tie the browser paints in DOM order, and the
 * assistant renders AFTER `<main>` (it shares AppLayout's row with it). On z-50 it would cover the
 * settings drawer's Logout and every page dialog. On z-40, a phone dock would hide the mobile nav
 * opened from the header above it.
 *
 * Kept as a literal here so Tailwind generates it (the content globs scan `src/**`).
 */
export const ASSISTANT_LAYER_CLASS = 'z-[35]'
